import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const getShopExchange = async () => {
  try {
    const data = await axiosInstance.get(API_ROUTES.ExchangeItem)
    return data.data || {}
  } catch (error) {
    return {}
  }
}
